import { WorkingDayDefinition } from '../helpers/maat-working-day-calculator';

export class DEADLINE {
  static readonly MaatAuditPlan: WorkingDayDefinition = {excludePublicHolidays: true, excludeWeekends: true };
  static readonly MaatNcq: WorkingDayDefinition = { excludePublicHolidays: true, excludeWeekends: false };
}
